export const GenerateJsonExcel = (dataPage) => {
  let jsonGerate = [];
  if (dataPage.indicador === '1') {
    jsonGerate = [
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Movimientos Cuentas Vista/Convenios'],
        combinado: true,
        seleccion: [
          [1, 1],
          [3, 1],
        ],
      },
      //Nombre de cuenta
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Nombre de la cuenta'],
        combinado: true,
        seleccion: [[1, 2]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.nombre],
        combinado: true,
        seleccion: [
          [2, 2],
          [3, 2],
        ],
      },
      //Numero de Cuenta
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Número de cuenta'],
        combinado: true,
        seleccion: [[1, 3]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.numero],
        combinado: true,
        seleccion: [
          [2, 3],
          [3, 3],
        ],
      },
      //Fecha creacion
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Fecha de creación o generación'],
        combinado: true,
        seleccion: [[1, 4]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.fecha],
        combinado: true,
        seleccion: [
          [2, 4],
          [3, 4],
        ],
      },
      //Saldo total
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Saldo Total'],
        combinado: true,
        seleccion: [[1, 5]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.salTotal],
        combinado: true,
        seleccion: [
          [2, 5],
          [3, 5],
        ],
      },
      //Saldo disponible
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Saldo Disponible'],
        combinado: true,
        seleccion: [[1, 6]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.salDispo],
        combinado: true,
        seleccion: [
          [2, 6],
          [3, 6],
        ],
      },
      //Supervision
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Cuenta en Supervision'],
        combinado: true,
        seleccion: [[1, 7]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.supervision ? 'SI' : 'NO'],
        combinado: true,
        seleccion: [
          [2, 7],
          [3, 7],
        ],
      },

      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Fecha de Transaccion'],
        combinado: true,
        seleccion: [
          [1, 9],
          [1, 10],
        ],
      },

      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Descripcion'],
        combinado: true,
        seleccion: [
          [2, 9],
          [2, 10],
        ],
      },

      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Monto'],
        combinado: true,
        seleccion: [
          [3, 9],
          [3, 10],
        ],
      },
      // {
      //   tipo: 'rango',
      //   estilos: {
      //     fondo: '',
      //     tamano: 12,
      //     borderTop: true,
      //     borderButon: true,
      //     borderLeft: true,
      //     borderRigth: true,
      //     alineacion: 'center',
      //   },
      //   valor: ['Monto'],
      //   combinado: true,
      //   seleccion: [
      //     [4, 9],
      //     [4, 10],
      //   ],
      // },
    ];
    let fila = 11;
    dataPage.listMov.map((item) => {
      jsonGerate.push({
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [item.fecha, item.descripcion, item.monto],
        combinado: false,
        seleccion: [
          [1, fila],
          [4, fila],
        ],
      });
      fila++;
    });
    //console.log(jsonGerate);
  }

  ////////////////////////creacion de json para prestamos///////////////////////
  else if (dataPage.indicador === '2') {
    jsonGerate = [
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Movimientos Cartera Vigente/Préstamos'],
        combinado: true,
        seleccion: [
          [1, 1],
          [3, 1],
        ],
      },
      //Nombre de la cuenta
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Nombre de la cuenta'],
        combinado: true,
        seleccion: [[1, 2]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.nombre],
        combinado: true,
        seleccion: [
          [2, 2],
          [3, 2],
        ],
      },
      // Numero de prestamo
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Número de prestamo'],
        combinado: true,
        seleccion: [[1, 3]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.numero],
        combinado: true,
        seleccion: [
          [2, 3],
          [3, 3],
        ],
      },
      //Fecha de creacion o generacion
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Fecha de creación o generación'],
        combinado: true,
        seleccion: [[1, 4]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.fecha],
        combinado: true,
        seleccion: [
          [2, 4],
          [3, 4],
        ],
      },
      // valor deuda
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Valor deuda'],
        combinado: true,
        seleccion: [[1, 5]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.deuda],
        combinado: true,
        seleccion: [
          [2, 5],
          [3, 5],
        ],
      },
      //Pago total a la fecha
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Pago Total a la fecha'],
        combinado: true,
        seleccion: [[1, 6]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.pagoTotalFecha],
        combinado: true,
        seleccion: [
          [2, 6],
          [3, 6],
        ],
      },
      //pago minimo a la fecha
      {
        tipo: 'celda',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'left',
        },
        valor: ['Pago minimo a la fecha'],
        combinado: true,
        seleccion: [[1, 7]],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [dataPage.pagoMinimoFecha],
        combinado: true,
        seleccion: [
          [2, 7],
          [3, 7],
        ],
      },
      //
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Fecha de Transaccion'],
        combinado: true,
        seleccion: [
          [1, 9],
          [1, 10],
        ],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Descripcion'],
        combinado: true,
        seleccion: [
          [2, 9],
          [2, 10],
        ],
      },
      {
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: ['Monto'],
        combinado: true,
        seleccion: [
          [3, 9],
          [3, 10],
        ],
      },
    ];
    let fila = 11;
    dataPage.listMov.map((item) => {
      jsonGerate.push({
        tipo: 'rango',
        estilos: {
          fondo: '',
          tamano: 12,
          borderTop: true,
          borderButon: true,
          borderLeft: true,
          borderRigth: true,
          alineacion: 'center',
        },
        valor: [item.fecha, item.descripcion, item.monto],
        combinado: false,
        seleccion: [
          [1, fila],
          [3, fila],
        ],
      });
      fila++;
    });
    //console.log(jsonGerate);
  }
  return jsonGerate;
};
